import * as React from 'react';
import {ITextProps} from './ITextProps';
import {Base} from './Base';

export const Tt5 = (props: ITextProps) => {
  return <Base typoClass="typo5" {...props} />;
};
